import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "./modal/Modal";
import { useTranslation } from "react-i18next";
import { states } from "../data/states";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useAppointmentContext } from "../context/AppointmentContext";
import toast from "react-hot-toast";
import { useMediaQuery } from "react-responsive";

function EmergencyContactForm() {
  const { t } = useTranslation();
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const {
    appointmentData,
    setAppointmentData,
    emergencyContactInfo,
    setEmergencyContactInfo,
    prevFormsInfo,
  } = useAppointmentContext();
  const navigate = useNavigate();
  const [showPopup_, setShowPopup_] = useState(false);

  useEffect(() => {
    if (appointmentData?.emergencyContactInfo) {
      setEmergencyContactInfo(JSON.parse(appointmentData.emergencyContactInfo));
      setShowPopup_(true);
      return;
    }

    if (prevFormsInfo?.emergencyContactInfo) {
      setEmergencyContactInfo(JSON.parse(prevFormsInfo.emergencyContactInfo));
      setAppointmentData((prev) => ({
        ...prev,
        emergencyContactInfo: prevFormsInfo.emergencyContactInfo,
      }));
      setShowPopup_(true);
      return;
    }
    setEmergencyContactInfo({
      name: "",
      phone: "",
      city: "",
      state: "",
    });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEmergencyContactInfo((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const username = sessionStorage.getItem("username");
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setemerFormData({
  //     ...emerformData,
  //     [name]: value === "Select City" ? "" : value,
  //   });
  // };

  //   fetchMedicalHistory();
  // }, []);

  const handleYes = () => {
    setShowPopup_(false);
  };

  const handleNo = () => {
    navigate("/doctor-info");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (
      !emergencyContactInfo.name ||
      !emergencyContactInfo.phone ||
      !emergencyContactInfo.city ||
      !emergencyContactInfo.state
    ) {
      toast.error(t("Please fill all the details"));
      return;
    }
    setAppointmentData((prev) => ({
      ...prev,
      emergencyContactInfo: JSON.stringify(emergencyContactInfo),
    }));
    navigate("/doctor-info");
  };

  const handlePrev = (e) => {
    e.preventDefault();
    navigate(-1);
  };

  return (
    <>
      <div className="w-full h-full flex flex-col items-center overflow-auto p-8 text-white">
        {showPopup_ && (
          <Modal>
            <h3 className="md:text-3xl text-xl font-bold mb-2 text-black text-center">
              {t("Do you want to update your emergency contact")}?
            </h3>
            <div className="flex gap-5">
              <button
                className="yellowButton py-2 px-8 rounded-3xl font-bold text-black"
                onClick={handleYes}
              >
                {t("Yes")}
              </button>
              <button
                className="yellowButton py-2 px-8 rounded-3xl font-bold text-black"
                onClick={handleNo}
              >
                {t("No")}
              </button>
            </div>
          </Modal>
        )}
        <label className="font-bold text-xl  md:text-4xl text-white  uppercase text-center">
          {t("Emergency Contact Information")}
        </label>
        <form
          className=" p-6 rounded-md flex flex-col shadow-md flex-1 w-full md:w-4/5 lg:w-2/3 xl:w-1/2 text-black"
          onSubmit={handleSubmit}
        >
          <div className="flex flex-col gap-3 flex-1 items-center">
            <div className="w-full max-w-md md:flex md:flex-row flex flex-col justify-between items-center gap-1">
              <label className="text-white font-semibold text-md md:w-20 w-full text-start">
                {t("Name")}:
              </label>
              <input
                className="bg-white text-black rounded-md m-1 p-1 md:flex-1 w-full"
                type="text"
                name="name"
                value={emergencyContactInfo?.name}
                onChange={handleInputChange}
              />
            </div>
            <div className="w-full max-w-md md:flex md:flex-row flex flex-col justify-between items-center gap-1">
              <label className="text-white font-semibold text-md md:w-[85px] w-full text-start">
                {t("Phone")}:
              </label>
              <div className="md:flex-1 w-full">
                <PhoneInput
                  country="us"
                  value={emergencyContactInfo?.phone}
                  onChange={(value) =>
                    setEmergencyContactInfo((prev) => ({
                      ...prev,
                      phone: value,
                    }))
                  }
                  inputStyle={{
                    width: isMobile ? "100% " : "98%",
                    zIndex: "0",
                  }}
                />
              </div>
            </div>
            <div className="w-full max-w-md md:flex md:flex-row flex flex-col justify-between items-center gap-1">
              <label className="text-white font-semibold text-md md:w-20 w-full text-start">
                {t("City")}:
              </label>
              <input
                className="bg-white text-black rounded-md m-1 p-1 md:flex-1 w-full"
                type="text"
                name="city"
                value={emergencyContactInfo?.city}
                onChange={handleInputChange}
              />
            </div>
            <div className="w-full max-w-md md:flex md:flex-row flex flex-col justify-between items-center gap-1">
              <label className="text-white font-semibold text-md md:w-20 w-full text-start">
                {t("State")}:
              </label>
              <select
                value={emergencyContactInfo?.state}
                name="state"
                className="rounded-md m-1 p-1 md:flex-1 w-full"
                onChange={handleInputChange}
              >
                <option value="">Select State</option>
                {states?.map((state, index) => {
                  return (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="flex justify-between">
            <button
              className="yellowButton py-2 px-8 rounded-3xl font-bold mt-4"
              onClick={handlePrev}
            >
              {t("Back")}
            </button>
            <button className="yellowButton py-2 px-8 rounded-3xl font-bold mt-4">
              {t("Submit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default EmergencyContactForm;

